export const ORDER_ID_LENGTH = 9;
